const Report = () => {
  return (
    <>
      <div className="bg-white 3xl:mt-[12px] shadow-[0px_5px_16px_rgba(0,0,0,0.06)] 3xl:pt-[30px] py-[28px] rounded-b-[20px] mt-[28px] pt-[60px] px-[37px] desktop:!mt-0">
        <div className="">Report</div>
      </div>
    </>
  );
};

export default Report;
